
import { Component, Vue } from 'vue-property-decorator';

import Form6ProcessHeader from "@/components/process/Form6/components/Form6ProcessHeader.vue";
import Form6CaseInformation from "@/components/process/Form6/components/Form6CaseInformation.vue";
import { form6StatusInfoType } from '@/types/Information/Form6';

@Component({
    components:{
        Form6ProcessHeader,
        Form6CaseInformation
    }
})
export default class StartForm6 extends Vue {

    stepsCompleted = {} as form6StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }  


}
